import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BranchAdd,
  BranchUpdate,
  LocationShowdata,
} from "../../../services/LoginPageService";

const BranchModal = ({
  open,
  setOpen,
  isAddButton,
  editBranch,
  setRefreshData,
  setNotification,
}) => {
  const [location, setLocation] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [branch, setBranch] = useState("");
  const [description, setDescription] = useState("");
const [smsSendTime,setTime] = useState('');
const [reportStartTime  ,setStartTime] = useState('');
const [reportEndTime,setEndTime] = useState('');
  const [deviceId, setDeviceId] = useState("");




setDeviceId
  const handleClose = () => {
    setOpen(false);
    ClearData();
  };

  useEffect(() => {
    LocationShowdata(handleLocationshow, handleLocationshowException);
    setStartTime(editBranch?.reportStartTime || '');
    setTime(editBranch?.smsSendTime || '');
    setEndTime(editBranch?.reportEndTime || '');
    setBranch(editBranch?.branch || "");
    setDescription(editBranch?.description || "");
    setDeviceId(editBranch?.deviceId || "");

    setLocation(editBranch?.locationId || "");
  }, [editBranch]);

  const handleLocationshow = (dataObject) => {
    setLocationList(dataObject?.data);
    console.log(dataObject?.data);
  };

  const handleLocationshowException = (error, errorMessage) => {
    console.log(errorMessage);
  };

  const isValidInput = (inputValue) => {
    // Regular expression to validate the input: only allow letters and spaces
    const regex = /^[A-Za-z\s]+$/;
    return regex.test(inputValue);
  };

  const handleBranchChange = (e) => {
    const inputValue = e.target.value;
    if (isValidInput(inputValue)) {
      setBranch(inputValue);
    } else {
      // Check if the input value is empty after backspace, then clear the location
      if (inputValue === "") {
        setBranch("");
      }
    }
  };

  const ClearData = () => {
    setBranch("");
    setDescription("");
    setDeviceId("");
    setLocation("");
    setTime('');
    setEndTime('');
    setStartTime('');
    setRefreshData((oldValue) => !oldValue);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    isAddButton === true
      ? BranchAdd(
          {
            location: location,
            description: description,
            deviceId:deviceId,
            branch: branch,
            smsSendTime:smsSendTime,
            reportEndTime:reportEndTime,
            reportStartTime:reportStartTime,
          },
          handleSuccess,
          handleException
        )
      : BranchUpdate(
          {
            id: editBranch.id,
            location: location,
            description: description,
            deviceId:deviceId,
            branch: branch,
            smsSendTime:smsSendTime,
            reportEndTime:reportEndTime,
            reportStartTime:reportStartTime,
          },
          handleSuccess,
          handleException
        );
  };

  const handleSuccess = (dataObject) => {
    console.log(dataObject);
    setNotification({
      status: true,
      type: "success",
      message: dataObject.message,
    });
    setTimeout(() => {
      setOpen(false);
    }, 2000);
    setRefreshData((oldValue) => !oldValue);
    ClearData();
  };

  const handleException = (errorObject, errorMessage) => {
    console.log(errorMessage);
    setNotification({
      status: true,
      type: "error",
      message: errorMessage,
    });
    ClearData();
  };

  const onLocationChange = (e) => {
    setLocation(e.target.value);
  };

  return (
    <div>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "32%", maxHeight: "100%" } }}
        maxWidth="lg"
        open={open}
      >
        <form onSubmit={onSubmit}>
          <DialogTitle style={{ background: "#f7f7f7", color: "black" }}>
            {isAddButton === true ? "Add " : "Update "}Course
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} style={{ marginTop: "20px" }}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Location
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Location"
                    placeholder="Location"
                    value={location}
                    required
                    onChange={(e) => onLocationChange(e)}
                  >
                    {locationList?.map((data, index) => {
                      return (
                        <MenuItem value={data.id} key={index}>
                          {data.location}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  label="Hostel Name"
                  placeholder="Hostel Name"
                  variant="outlined"
                  required
                  onChange={handleBranchChange}
                  // onChange={(e) => { setBranch(e.target.value) }}
                  value={branch}
                />
              </Grid>
              
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  label="Report Start"
                  placeholder="Report Start"
                  variant="outlined"
                  required
                  type="time"
                  onChange={(e) => {
                    setStartTime(e.target.value);
                  }}
                  value={reportStartTime}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  label="Report End"
                  placeholder="Report End"
                  variant="outlined"
                  required
                  type="time"
                  onChange={(e) => {
                    setEndTime(e.target.value);
                  }}
                  value={reportEndTime}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  label="SMS Sent At"
                  placeholder="SMS Sent At"
                  variant="outlined"
                  required
                  type="time"
                  onChange={(e) => {
                    setTime(e.target.value);
                  }}
                  value={smsSendTime}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  label="Device Id"
                  placeholder="Device Id"
                  variant="outlined"
                  required
                  onChange={(e) => {
                    setDeviceId(e.target.value);
                  }}
                  value={deviceId}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Description"
                  variant="outlined"
                  required
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                  value={description}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit">{isAddButton ? "Add" : "update"}</Button>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default BranchModal;
